import { cva } from "class-variance-authority";

/** Canvas floating toolbar chrome — mirrors user-dashboard canvas toolbar spec. */
export const canvasToolbarShellVariants = cva(
  [
    "inline-flex",
    "bg-n-00 border border-n-10 rounded-lg shadow-elev-5",
    "p-1 gap-0.5",
  ],
  {
    variants: {
      orientation: {
        horizontal: "flex-row flex-nowrap items-center",
        vertical: "flex-col items-stretch w-[42px]",
      },
    },
    defaultVariants: {
      orientation: "horizontal",
    },
  },
);

export const canvasToolbarDividerVariants = cva("bg-n-10 shrink-0", {
  variants: {
    orientation: {
      horizontal: "w-px mx-1 self-stretch my-1",
      vertical: "h-px mx-1 my-1 self-auto w-auto",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export const canvasToolbarButtonVariants = cva(
  [
    "relative inline-flex items-center justify-center gap-0.5",
    "h-8 min-w-8 px-1.5",
    "rounded-sm border-0 bg-transparent",
    "text-n-90 cursor-pointer outline-none",
    "transition-[background-color,color,opacity] duration-150 ease-out",
    "hover:duration-100 hover:bg-n-10",
    "active:duration-75 active:opacity-92",
    "focus-visible:outline-[1.5px] focus-visible:outline-rust focus-visible:outline-offset-0.5",
    "disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none",
    "disabled:hover:bg-transparent",
    "aria-expanded:bg-n-10",
  ],
  {
    variants: {
      active: {
        true: [
          "bg-[color-mix(in_oklab,var(--rust)_12%,transparent)] text-rust",
          "hover:bg-[color-mix(in_oklab,var(--rust)_18%,transparent)]",
        ],
        false: "",
      },
      destructive: {
        true: "text-lc-blocked hover:bg-lc-blocked/10",
        false: "",
      },
      accent: {
        true: "text-plum hover:bg-plum/10",
        false: "",
      },
    },
    defaultVariants: {
      active: false,
      destructive: false,
      accent: false,
    },
  },
);
